import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'

export default RouteGroup({

  prefix: '/categories',

  routes: [
    Route('/:type', 'categories.index', view('categories/Index')),
    Route('/:type/create', 'category.create', view('categories/Create')),
    Route('/:type/:category/edit', 'category.edit', view('categories/Edit')),
  ]
})